export function generateKey(title, url, slug) {
  return "".concat(title, "-").concat(url, "-").concat(slug);
}